<template>
	<div id="app">
		<b-container fluid="">
			<b-row class="bg-success" style="padding-bottom:8px; padding-top:8px; ">
				<b-col class="text-center">
					<h3 class="text-light">{{ mainTitle }}</h3>
				</b-col>
			</b-row>
		</b-container>
		<b-container>
			<b-row>
				<!-- <b-col v-for='(step, index) of steps' :key='index'>
					<b-link :to='"/" + step[1]'>{{ step[2] }}</b-link>
				</b-col> -->
				<hr />
			</b-row>
			<router-view/>
		</b-container>
	</div>
</template>


<script>
import steps from './steps.js'
import session from './session.js'
import axios from 'axios'

export default {
	metaInfo: {
		title: 'Эко-Сити | Договор-онлайн',
		htmlAttrs: {
        lang: 'ru',
        amp: true
		}
	},
	data() {
		return {
			steps: steps.items,
			mainTitle: '',
		}
	},
	created() {
		this.loadMainTitle()
		this.$store.dispatch('LOAD_FTE')
		//
		let uuidCookieName = 'request_uuid'
		let uuidFromCookie = this.$cookies.get(uuidCookieName)
		if(uuidFromCookie && uuidFromCookie.length > 12) {
			this.$store.commit('UUID', uuidFromCookie)
		} else {
			session.getUuidFromRemote().then(newUuid => {
				this.$cookies.set(uuidCookieName, newUuid)
				this.$store.commit('UUID', newUuid)
			})
		}
	},
	methods: {
		loadMainTitle() {
			if(!window.$eco) {
				axios.get('https://static.roecocity.ru/eco-variables.json')
				.then(res => {
					window.$eco = res.data
					this.mainTitle = window.$eco.name.full
				})
			}
			return window.$eco ? window.$eco.name.full : ''
		}
	}
}
</script>
